module.exports = __webpack_public_path__ + "img/404.b2c9c04d.svg";